import { getActiveParkingId } from "../../utils/tenant";
import React, { useState, useEffect, useRef } from "react";
import { getAuth } from "firebase/auth";
import { 
    getFirestore, collection, addDoc, deleteDoc, doc, onSnapshot, query, orderBy, where, getDocs, setDoc 
} from "firebase/firestore";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import mn from "date-fns/locale/mn";
import { 
    FiSettings, FiBriefcase, FiClock, FiPlus, FiTrash2, FiLayers, FiAward,
    FiCalendar, FiUserCheck, FiUsers, FiSearch, FiChevronDown, FiShield, FiLock
} from "react-icons/fi";

registerLocale("mn", mn);
const MySwal = withReactContent(Swal);

// ⭐️ MINIMAL TOAST NOTIFICATION
const Toast = MySwal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    iconColor: '#10b981',
    customClass: {
        popup: 'tw-bg-white tw-rounded-xl tw-shadow-lg tw-border tw-border-slate-100 tw-px-4 tw-py-3',
        title: 'tw-text-sm tw-font-bold tw-text-slate-800 tw-m-0',
        timerProgressBar: 'tw-bg-slate-200'
    }
});

// ⭐️ MINIMAL WARNING ALERT (Ашиглагдаж буйг сануулах)
const showWarningAlert = (itemName) => {
    MySwal.fire({
        html: `
            <div class="tw-text-center tw-pt-2">
                <div class="tw-w-12 tw-h-12 tw-bg-amber-50 tw-text-amber-500 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4">
                    <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
                </div>
                <h3 class="tw-text-base tw-font-bold tw-text-slate-800 tw-m-0">Устгах боломжгүй</h3>
                <p class="tw-text-sm tw-text-slate-500 tw-mt-2 tw-mb-0 tw-leading-relaxed"><b>"${itemName}"</b> нь ажилтнуудын бүртгэлд ашиглагдаж байна. Устгахын тулд эхлээд тухайн ажилтнуудын мэдээллийг өөрчилнө үү.</p>
            </div>
        `,
        showConfirmButton: true,
        confirmButtonText: 'Ойлголоо',
        buttonsStyling: false,
        customClass: {
            popup: 'tw-rounded-2xl tw-p-5 tw-shadow-2xl tw-border tw-border-slate-100 tw-max-w-xs',
            confirmButton: 'tw-w-full tw-bg-slate-800 hover:tw-bg-slate-900 tw-text-white tw-font-bold tw-py-2.5 tw-rounded-xl tw-mt-6 tw-text-sm tw-transition-colors'
        }
    });
};

// ⭐️ MINIMAL CONFIRMATION DIALOG (Устгахыг асуух)
const confirmDelete = async (itemName, type) => {
    const result = await MySwal.fire({
        html: `
            <div class="tw-flex tw-flex-col tw-items-center tw-text-center tw-pt-2">
                <div class="tw-w-12 tw-h-12 tw-bg-rose-50 tw-text-rose-500 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mb-4">
                    <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                </div>
                <h3 class="tw-text-base tw-font-bold tw-text-slate-800 tw-m-0">Устгах уу?</h3>
                <p class="tw-text-sm tw-text-slate-500 tw-mt-2 tw-mb-0 tw-leading-relaxed">Та <b>"${itemName}"</b> ${type}-г системээс бүр мөсөн устгах гэж байна.</p>
            </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Устгах',
        cancelButtonText: 'Болих',
        buttonsStyling: false,
        customClass: {
            popup: 'tw-rounded-2xl tw-p-5 tw-shadow-2xl tw-border tw-border-slate-100 tw-max-w-xs',
            actions: 'tw-flex tw-gap-3 tw-w-full tw-mt-6',
            confirmButton: 'tw-flex-1 tw-bg-rose-500 hover:tw-bg-rose-600 tw-text-white tw-font-bold tw-py-2.5 tw-rounded-xl tw-transition-colors tw-text-sm',
            cancelButton: 'tw-flex-1 tw-bg-slate-100 hover:tw-bg-slate-200 tw-text-slate-600 tw-font-bold tw-py-2.5 tw-rounded-xl tw-transition-colors tw-text-sm'
        }
    });
    return result.isConfirmed;
};


export default function Controller() {
    const [departments, setDepartments] = useState([]);
    const [jobTitles, setJobTitles] = useState([]); 
    const [schedules, setSchedules] = useState([]);
    const [holidays, setHolidays] = useState([]);   
    const [employmentTypes, setEmploymentTypes] = useState([]); 
    const [employees, setEmployees] = useState([]); 
    const [approvers, setApprovers] = useState([]); 
    
    // ⭐️ СИСТЕМИЙН ҮНДСЭН ТОХИРГОО (ХАТУУ ДҮРЭМ)
    const [systemRules, setSystemRules] = useState({ isStrictMode: false });
    const [isAdmin, setIsAdmin] = useState(false); // Эрх шалгах

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    const [newDeptName, setNewDeptName] = useState("");
    const [newJobTitle, setNewJobTitle] = useState("");
    const [newSchedule, setNewSchedule] = useState({ name: "", startTime: "08:00", endTime: "17:00" });
    const [newHoliday, setNewHoliday] = useState({ date: new Date(), name: "" }); 
    const [newEmpType, setNewEmpType] = useState(""); 
    
    // ⭐️ ХАЙЖ БОЛДОГ DROPDOWN-Д ЗОРИУЛСАН STATE
    const [selectedApproverEmp, setSelectedApproverEmp] = useState(null); 
    const [isApproverDropdownOpen, setIsApproverDropdownOpen] = useState(false);
    const [approverSearchText, setApproverSearchText] = useState("");
    const dropdownRef = useRef(null);

    const db = getFirestore();
    const auth = getAuth();

    const dateToString = (d) => {
        if (!d) return "";
        const pad = n => n.toString().padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    };

    // Гадна дарвал Dropdown хаагдах логик
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsApproverDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // ⭐️ ХЭРЭГЛЭГЧИЙН ЭРХ ШАЛГАХ (Зөвхөн удирдах албан тушаалтан дүрэм солино)
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user && user.email) {
                try {
                    const q = query(collection(db, "parkings", getActiveParkingId(), "employees"), where("email", "==", user.email));
                    const snap = await getDocs(q);
                    if (!snap.empty) {
                        const empData = snap.docs[0].data();
                        const role = empData.position || "";
                        if (["Менежер", "HR Менежер", "Захирал", "Нягтлан бодогч"].includes(role)) {
                            setIsAdmin(true);
                        } else {
                            setIsAdmin(false);
                        }
                    }
                } catch (error) { console.error("Эрх шалгахад алдаа:", error); }
            }
        });
        return () => unsubscribe();
    }, [auth, db]);

    // ДАТА ТАТАХ
    useEffect(() => {
        setIsLoading(true);
        const unsubDept = onSnapshot(query(collection(db, "parkings", getActiveParkingId(), "departments"), orderBy("createdAt", "asc")), (snapshot) => { setDepartments(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); });
        const unsubJobs = onSnapshot(query(collection(db, "parkings", getActiveParkingId(), "job_titles"), orderBy("createdAt", "asc")), (snapshot) => { setJobTitles(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); });
        const unsubSched = onSnapshot(query(collection(db, "parkings", getActiveParkingId(), "schedules"), orderBy("createdAt", "asc")), (snapshot) => { setSchedules(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); });
        const unsubHolidays = onSnapshot(query(collection(db, "parkings", getActiveParkingId(), "holidays"), orderBy("date", "asc")), (snapshot) => { setHolidays(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); });
        const unsubEmpTypes = onSnapshot(query(collection(db, "parkings", getActiveParkingId(), "employment_types"), orderBy("createdAt", "asc")), (snapshot) => { setEmploymentTypes(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); });
        const unsubEmps = onSnapshot(collection(db, "parkings", getActiveParkingId(), "employees"), (snapshot) => { setEmployees(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); });
        const unsubApprovers = onSnapshot(collection(db, "parkings", getActiveParkingId(), "approvers"), (snapshot) => { 
            setApprovers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); 
            setIsLoading(false); 
        });

        // ⭐️ Хатуу дүрмийн тохиргоог татах
        const unsubRules = onSnapshot(doc(db, "parkings", getActiveParkingId(), "settings", "general"), (d) => {
            if (d.exists()) {
                setSystemRules(d.data());
            } else {
                setSystemRules({ isStrictMode: false });
            }
        });

        return () => { unsubDept(); unsubJobs(); unsubSched(); unsubHolidays(); unsubEmpTypes(); unsubEmps(); unsubApprovers(); unsubRules(); };
    }, [db]);

    // ⭐️ ХАТУУ ДҮРЭМ АСААХ/УНТРААХ
    const handleToggleStrictMode = async () => {
        if (!isAdmin) {
            return MySwal.fire({
                icon: 'warning',
                title: 'Эрх хүрэхгүй байна',
                text: 'Зөвхөн удирдах албан тушаалтан цагийн дүрмийг өөрчлөх эрхтэй.',
                confirmButtonColor: '#3b82f6',
                customClass: { popup: 'tw-rounded-2xl tw-p-6', confirmButton: 'tw-rounded-xl tw-font-bold' }
            });
        }

        try {
            const docRef = doc(db, "parkings", getActiveParkingId(), "settings", "general");
            const newMode = !systemRules.isStrictMode;
            // merge: true нь бусад тохиргоог устгахгүйгээр зөвхөн isStrictMode-г шинэчилнэ
            await setDoc(docRef, { isStrictMode: newMode }, { merge: true });
            Toast.fire({ 
                icon: 'success', 
                title: ` ${newMode ? 'асаалттай' : 'унтраалттай'} боллоо` 
            });
        } catch (error) {
            Toast.fire({ icon: 'error', title: 'Тохиргоо хадгалагдсангүй' });
        }
    };


    // 1. ХЭЛТЭС
    const handleAddDepartment = async (e) => {
        e.preventDefault(); if (!newDeptName.trim()) return; setIsSaving(true);
        try { await addDoc(collection(db, "parkings", getActiveParkingId(), "departments"), { name: newDeptName.trim(), createdAt: new Date() }); Toast.fire({ icon: 'success', title: 'Хэлтэс нэмэгдлээ' }); setNewDeptName(""); } 
        catch (error) { Toast.fire({ icon: 'error', title: 'Алдаа гарлаа' }); } finally { setIsSaving(false); }
    };
    const handleDeleteDept = async (id, name) => {
        const inUse = employees.some(emp => emp.department === name);
        if (inUse) return showWarningAlert(name);
        if (await confirmDelete(name, "хэлтсийг")) {
            await deleteDoc(doc(db, "parkings", getActiveParkingId(), "departments", id));
            Toast.fire({ icon: 'success', title: 'Амжилттай устгалаа' });
        }
    };

    // 2. АЛБАН ТУШААЛ
    const handleAddJobTitle = async (e) => {
        e.preventDefault(); if (!newJobTitle.trim()) return; setIsSaving(true);
        try { await addDoc(collection(db, "parkings", getActiveParkingId(), "job_titles"), { name: newJobTitle.trim(), createdAt: new Date() }); Toast.fire({ icon: 'success', title: 'Албан тушаал нэмэгдлээ' }); setNewJobTitle(""); } 
        catch (error) { Toast.fire({ icon: 'error', title: 'Алдаа гарлаа' }); } finally { setIsSaving(false); }
    };
    const handleDeleteJob = async (id, name) => {
        const inUse = employees.some(emp => emp.position === name || emp.jobTitle === name);
        if (inUse) return showWarningAlert(name);
        if (await confirmDelete(name, "албан тушаалыг")) {
            await deleteDoc(doc(db, "parkings", getActiveParkingId(), "job_titles", id));
            Toast.fire({ icon: 'success', title: 'Амжилттай устгалаа' });
        }
    };

    // 3. АЖИЛЛАХ ХЭЛБЭР
    const handleAddEmpType = async (e) => {
        e.preventDefault(); if (!newEmpType.trim()) return; setIsSaving(true);
        try { await addDoc(collection(db, "parkings", getActiveParkingId(), "employment_types"), { name: newEmpType.trim(), createdAt: new Date() }); Toast.fire({ icon: 'success', title: 'Ажиллах хэлбэр нэмэгдлээ' }); setNewEmpType(""); } 
        catch (error) { Toast.fire({ icon: 'error', title: 'Алдаа гарлаа' }); } finally { setIsSaving(false); }
    };
    const handleDeleteEmpType = async (id, name) => {
        const inUse = employees.some(emp => emp.employmentType === name);
        if (inUse) return showWarningAlert(name);
        if (await confirmDelete(name, "ажиллах хэлбэрийг")) {
            await deleteDoc(doc(db, "parkings", getActiveParkingId(), "employment_types", id));
            Toast.fire({ icon: 'success', title: 'Амжилттай устгалаа' });
        }
    };

    // 4. ЦАГИЙН ХУВААРЬ
    const handleAddSchedule = async (e) => {
        e.preventDefault(); if (!newSchedule.name || !newSchedule.startTime || !newSchedule.endTime) return Toast.fire({ icon: 'warning', title: 'Бүрэн бөглөнө үү' }); setIsSaving(true);
        try {
            const scheduleString = `${newSchedule.startTime} - ${newSchedule.endTime}`;
            await addDoc(collection(db, "parkings", getActiveParkingId(), "schedules"), { name: newSchedule.name.trim(), schedule: scheduleString, startTime: newSchedule.startTime, endTime: newSchedule.endTime, createdAt: new Date() });
            Toast.fire({ icon: 'success', title: 'Хуваарь нэмэгдлээ' }); setNewSchedule({ name: "", startTime: "08:00", endTime: "17:00" });
        } catch (error) { Toast.fire({ icon: 'error', title: 'Алдаа гарлаа' }); } finally { setIsSaving(false); }
    };
    const handleDeleteSchedule = async (id, name, scheduleString) => {
        const inUse = employees.some(emp => emp.workSchedule === scheduleString);
        if (inUse) return showWarningAlert(name);
        if (await confirmDelete(name, "хуваарийг")) {
            await deleteDoc(doc(db, "parkings", getActiveParkingId(), "schedules", id));
            Toast.fire({ icon: 'success', title: 'Амжилттай устгалаа' });
        }
    };

    // 5. БАЯРЫН ӨДӨР
    const handleAddHoliday = async (e) => {
        e.preventDefault(); if (!newHoliday.date || !newHoliday.name.trim()) return; setIsSaving(true);
        try { await addDoc(collection(db, "parkings", getActiveParkingId(), "holidays"), { date: dateToString(newHoliday.date), name: newHoliday.name.trim(), createdAt: new Date() }); Toast.fire({ icon: 'success', title: 'Баярын өдөр бүртгэгдлээ' }); setNewHoliday({ date: new Date(), name: "" }); } 
        catch (error) { Toast.fire({ icon: 'error', title: 'Алдаа гарлаа' }); } finally { setIsSaving(false); }
    };
    const handleDeleteHoliday = async (id, name) => {
        if (await confirmDelete(name, "баярын өдрийг")) {
            await deleteDoc(doc(db, "parkings", getActiveParkingId(), "holidays", id));
            Toast.fire({ icon: 'success', title: 'Амжилттай устгалаа' });
        }
    };

    // 6. ХҮСЭЛТ БАТЛАХ ЭРХТЭЙ УДИРДЛАГА (Searchable)
    const handleAddApprover = async (e) => {
        e.preventDefault(); 
        if (!selectedApproverEmp) return Toast.fire({ icon: 'warning', title: 'Ажилтан сонгоно уу' });
        if (!selectedApproverEmp.email) return Toast.fire({ icon: 'error', title: 'Имэйл бүртгэлгүй байна' });
        
        const isExists = approvers.some(a => a.emp_id === selectedApproverEmp.emp_id);
        if (isExists) return Toast.fire({ icon: 'warning', title: 'Аль хэдийн бүртгэгдсэн байна' });

        setIsSaving(true);
        try {
            await addDoc(collection(db, "parkings", getActiveParkingId(), "approvers"), { 
                emp_id: selectedApproverEmp.emp_id, 
                name: `${selectedApproverEmp.lastName?.charAt(0) || ''}. ${selectedApproverEmp.firstName || selectedApproverEmp.name}`, 
                email: selectedApproverEmp.email, 
                department: selectedApproverEmp.department || "", 
                position: selectedApproverEmp.position || "", 
                createdAt: new Date() 
            });
            Toast.fire({ icon: 'success', title: 'Эрх олголоо' }); 
            setSelectedApproverEmp(null);
            setApproverSearchText("");
        } catch (error) { 
            Toast.fire({ icon: 'error', title: 'Алдаа гарлаа' }); 
        } finally { 
            setIsSaving(false); 
        }
    };
    
    const handleDeleteApprover = async (id, name) => {
        if (await confirmDelete(name, "-н эрхийг")) {
            await deleteDoc(doc(db, "parkings", getActiveParkingId(), "approvers", id));
            Toast.fire({ icon: 'success', title: 'Эрх хасагдлаа' });
        }
    };

    const highlightedHolidays = holidays.map(h => new Date(h.date));
    
    // Ажилтан хайх filter
    const filteredEmployeesForDropdown = employees.filter(emp => {
        const query = approverSearchText.toLowerCase();
        const fullName = `${emp.lastName || ''} ${emp.firstName || emp.name || ''}`.toLowerCase();
        const code = (emp.emp_id || '').toLowerCase();
        return fullName.includes(query) || code.includes(query);
    });

    return (
        <div className="tw-bg-white tw-min-h-screen tw-p-4 sm:tw-p-6 lg:tw-p-8 tw-font-sans tw-text-slate-800">
            
            <div className="tw-mb-8 tw-pb-6 tw-border-b tw-border-slate-200">
                <h2 className="tw-text-2xl lg:tw-text-3xl tw-font-black tw-text-slate-900 tw-tracking-tight tw-m-0 tw-flex tw-items-center tw-gap-3">
                    <div className="tw-p-2 tw-bg-indigo-600 tw-text-white tw-rounded-xl tw-shadow-md"><FiSettings size={22} /></div>
                    Системийн Тохиргоо
                </h2>
                <p className="tw-text-sm tw-text-slate-500 tw-mt-2 tw-mb-0 tw-ml-[52px]">
                    Хүний нөөцийн бүртгэлийн үндсэн өгөгдөл болон дүрмийн тохиргоог энд хийнэ.
                </p>
            </div>

            {/* ⭐️ ЕРӨНХИЙ ТОХИРГОО (ХАТУУ ДҮРЭМ) */}
            <div className="tw-bg-slate-50/50 tw-rounded-2xl tw-shadow-sm tw-border tw-border-slate-200 tw-p-6 tw-mb-8 tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start sm:tw-items-center tw-gap-6">
                <div>
                    <h3 className="tw-text-base tw-font-bold tw-text-slate-800 tw-m-0 tw-flex tw-items-center tw-gap-2">
                        <FiShield className={systemRules.isStrictMode ? "tw-text-rose-500" : "tw-text-indigo-500"} size={20} /> 
                        Цаг тооцох дүрэм
                    </h3>
                    <p className="tw-text-sm tw-text-slate-500 tw-mt-2 tw-mb-0 tw-max-w-3xl tw-leading-relaxed">
                        <b>Асаалттай үед:</b> Ажилтан өглөө хоцорч ирсэн бол орой илүү сууж цагаа нөхөхийг хориглоно.<br/>
                        <b>Унтраалттай үед:</b> Орой нөхөж суугаад тухайн өдрийн ажиллах ёстой цагаа гүйцээх боломжтой.
                    </p>
                </div>
                
                <button 
                    onClick={handleToggleStrictMode} 
                    className={`tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-3 tw-rounded-xl tw-font-bold tw-text-sm tw-shadow-sm tw-transition-all tw-whitespace-nowrap ${systemRules.isStrictMode ? 'tw-bg-rose-50 tw-text-rose-700 tw-border tw-border-rose-200 hover:tw-bg-rose-100' : 'tw-bg-white tw-text-slate-600 tw-border tw-border-slate-200 hover:tw-bg-slate-50'} ${!isAdmin && 'tw-opacity-80 tw-cursor-not-allowed'}`}
                    title={!isAdmin ? "Эрх хүрэхгүй байна" : "Дарж солих"}
                >
                    <div className={`tw-w-3 tw-h-3 tw-rounded-full ${systemRules.isStrictMode ? 'tw-bg-rose-500 tw-animate-pulse' : 'tw-bg-slate-300'}`}></div>
                    {systemRules.isStrictMode ? "АСААЛТТАЙ" : "УНТРААЛТТАЙ"}
                    {!isAdmin && <FiLock size={14} className="tw-ml-2 tw-text-slate-400" />}
                </button>
            </div>

            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-mb-8">
                
                {/* 1. ХЭЛТЭС */}
                <div className="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border tw-border-slate-200 tw-overflow-hidden tw-flex tw-flex-col tw-h-[450px]">
                    <div className="tw-px-6 tw-py-4 tw-border-b tw-border-slate-200 tw-bg-slate-50/50 tw-flex tw-items-center tw-gap-2">
                        <FiBriefcase className="tw-text-blue-500" size={18} />
                        <h3 className="tw-text-sm tw-font-bold tw-text-slate-800 tw-m-0 tw-uppercase tw-tracking-wider">Хэлтэс / Алба</h3>
                    </div>
                    <form onSubmit={handleAddDepartment} className="tw-p-4 tw-border-b tw-border-slate-200 tw-bg-white tw-flex-shrink-0">
                        <div className="tw-flex tw-gap-2">
                            <input type="text" required placeholder="Ж: Хүний нөөцийн хэлтэс" value={newDeptName} onChange={(e) => setNewDeptName(e.target.value)} className="tw-flex-1 tw-px-4 tw-py-2 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg tw-text-sm tw-font-medium focus:tw-outline-none focus:tw-border-blue-500 focus:tw-bg-white tw-transition-colors" />
                            <button type="submit" disabled={isSaving} className="tw-px-4 tw-py-2 tw-bg-slate-800 hover:tw-bg-slate-900 tw-text-white tw-rounded-lg tw-font-bold tw-text-sm tw-transition-colors"><FiPlus className="tw-inline" /> Нэмэх</button>
                        </div>
                    </form>
                    <div className="tw-p-4 tw-overflow-y-auto tw-flex-1 custom-scrollbar">
                        {isLoading ? <div className="tw-text-center tw-text-blue-500 tw-text-sm tw-py-10">Уншиж байна...</div> : departments.length === 0 ? <div className="tw-text-center tw-text-slate-400 tw-text-sm tw-py-10">Хоосон байна.</div> : (
                            <ul className="tw-m-0 tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-2">
                                {departments.map((dept, idx) => (
                                    <li key={dept.id} className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-lg tw-px-4 tw-py-2 tw-flex tw-justify-between tw-items-center hover:tw-border-blue-300 tw-transition-colors group">
                                        <div className="tw-flex tw-items-center tw-gap-3">
                                            <div className="tw-w-6 tw-h-6 tw-bg-blue-50 tw-text-blue-600 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-xs">{idx + 1}</div>
                                            <span className="tw-font-bold tw-text-slate-700 tw-text-sm">{dept.name}</span>
                                        </div>
                                        <button onClick={() => handleDeleteDept(dept.id, dept.name)} className="tw-p-2 tw-bg-rose-50 hover:tw-bg-rose-500 tw-text-rose-500 hover:tw-text-white tw-rounded-lg tw-transition-colors" title="Устгах">
                                            <FiTrash2 size={16} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {/* 2. АЛБАН ТУШААЛ */}
                <div className="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border tw-border-slate-200 tw-overflow-hidden tw-flex tw-flex-col tw-h-[450px]">
                    <div className="tw-px-6 tw-py-4 tw-border-b tw-border-slate-200 tw-bg-slate-50/50 tw-flex tw-items-center tw-gap-2">
                        <FiAward className="tw-text-teal-500" size={18} />
                        <h3 className="tw-text-sm tw-font-bold tw-text-slate-800 tw-m-0 tw-uppercase tw-tracking-wider">Албан тушаал</h3>
                    </div>
                    <form onSubmit={handleAddJobTitle} className="tw-p-4 tw-border-b tw-border-slate-200 tw-bg-white tw-flex-shrink-0">
                        <div className="tw-flex tw-gap-2">
                            <input type="text" required placeholder="Ж: Ахлах мэргэжилтэн" value={newJobTitle} onChange={(e) => setNewJobTitle(e.target.value)} className="tw-flex-1 tw-px-4 tw-py-2 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg tw-text-sm tw-font-medium focus:tw-outline-none focus:tw-border-teal-500 focus:tw-bg-white tw-transition-colors" />
                            <button type="submit" disabled={isSaving} className="tw-px-4 tw-py-2 tw-bg-slate-800 hover:tw-bg-slate-900 tw-text-white tw-rounded-lg tw-font-bold tw-text-sm tw-transition-colors"><FiPlus className="tw-inline" /> Нэмэх</button>
                        </div>
                    </form>
                    <div className="tw-p-4 tw-overflow-y-auto tw-flex-1 custom-scrollbar">
                        {isLoading ? <div className="tw-text-center tw-text-teal-500 tw-text-sm tw-py-10">Уншиж байна...</div> : jobTitles.length === 0 ? <div className="tw-text-center tw-text-slate-400 tw-text-sm tw-py-10">Хоосон байна.</div> : (
                            <ul className="tw-m-0 tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-2">
                                {jobTitles.map((job, idx) => (
                                    <li key={job.id} className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-lg tw-px-4 tw-py-2 tw-flex tw-justify-between tw-items-center hover:tw-border-teal-300 tw-transition-colors group">
                                        <div className="tw-flex tw-items-center tw-gap-3">
                                            <div className="tw-w-6 tw-h-6 tw-bg-teal-50 tw-text-teal-600 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-xs">{idx + 1}</div>
                                            <span className="tw-font-bold tw-text-slate-700 tw-text-sm">{job.name}</span>
                                        </div>
                                        <button onClick={() => handleDeleteJob(job.id, job.name)} className="tw-p-2 tw-bg-rose-50 hover:tw-bg-rose-500 tw-text-rose-500 hover:tw-text-white tw-rounded-lg tw-transition-colors" title="Устгах">
                                            <FiTrash2 size={16} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {/* 3. АЖИЛЛАХ ХЭЛБЭР */}
                <div className="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border tw-border-slate-200 tw-overflow-hidden tw-flex tw-flex-col tw-h-[450px]">
                    <div className="tw-px-6 tw-py-4 tw-border-b tw-border-slate-200 tw-bg-slate-50/50 tw-flex tw-items-center tw-gap-2">
                        <FiUsers className="tw-text-purple-500" size={18} />
                        <h3 className="tw-text-sm tw-font-bold tw-text-slate-800 tw-m-0 tw-uppercase tw-tracking-wider">Ажиллах хэлбэр</h3>
                    </div>
                    <form onSubmit={handleAddEmpType} className="tw-p-4 tw-border-b tw-border-slate-200 tw-bg-white tw-flex-shrink-0">
                        <div className="tw-flex tw-gap-2">
                            <input type="text" required placeholder="Ж: Үндсэн ажилтан, Гэрээт..." value={newEmpType} onChange={(e) => setNewEmpType(e.target.value)} className="tw-flex-1 tw-px-4 tw-py-2 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg tw-text-sm tw-font-medium focus:tw-outline-none focus:tw-border-purple-500 focus:tw-bg-white tw-transition-colors" />
                            <button type="submit" disabled={isSaving} className="tw-px-4 tw-py-2 tw-bg-slate-800 hover:tw-bg-slate-900 tw-text-white tw-rounded-lg tw-font-bold tw-text-sm tw-transition-colors"><FiPlus className="tw-inline" /> Нэмэх</button>
                        </div>
                    </form>
                    <div className="tw-p-4 tw-overflow-y-auto tw-flex-1 custom-scrollbar">
                        {isLoading ? <div className="tw-text-center tw-text-purple-500 tw-text-sm tw-py-10">Уншиж байна...</div> : employmentTypes.length === 0 ? <div className="tw-text-center tw-text-slate-400 tw-text-sm tw-py-10">Хоосон байна.</div> : (
                            <ul className="tw-m-0 tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-2">
                                {employmentTypes.map((type, idx) => (
                                    <li key={type.id} className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-lg tw-px-4 tw-py-2 tw-flex tw-justify-between tw-items-center hover:tw-border-purple-300 tw-transition-colors group">
                                        <div className="tw-flex tw-items-center tw-gap-3">
                                            <div className="tw-w-6 tw-h-6 tw-bg-purple-50 tw-text-purple-600 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-xs">{idx + 1}</div>
                                            <span className="tw-font-bold tw-text-slate-700 tw-text-sm">{type.name}</span>
                                        </div>
                                        <button onClick={() => handleDeleteEmpType(type.id, type.name)} className="tw-p-2 tw-bg-rose-50 hover:tw-bg-rose-500 tw-text-rose-500 hover:tw-text-white tw-rounded-lg tw-transition-colors" title="Устгах">
                                            <FiTrash2 size={16} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {/* 4. ЦАГИЙН ХУВААРЬ */}
                <div className="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border tw-border-slate-200 tw-overflow-hidden tw-flex tw-flex-col tw-h-[450px]">
                    <div className="tw-px-6 tw-py-4 tw-border-b tw-border-slate-200 tw-bg-slate-50/50 tw-flex tw-items-center tw-gap-2">
                        <FiClock className="tw-text-amber-500" size={18} />
                        <h3 className="tw-text-sm tw-font-bold tw-text-slate-800 tw-m-0 tw-uppercase tw-tracking-wider">Ажлын цагийн хуваарь</h3>
                    </div>
                    <form onSubmit={handleAddSchedule} className="tw-p-4 tw-border-b tw-border-slate-200 tw-bg-white tw-flex-shrink-0">
                        <div className="tw-grid tw-grid-cols-2 tw-gap-2 tw-mb-3">
                            <div className="tw-col-span-2">
                                <input type="text" required placeholder="Хуваарийн нэр (Ж: Өдрийн ээлж)" value={newSchedule.name} onChange={(e) => setNewSchedule({...newSchedule, name: e.target.value})} className="tw-w-full tw-px-4 tw-py-2.5 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg tw-text-sm tw-font-medium focus:tw-outline-none focus:tw-border-amber-500 focus:tw-bg-white tw-transition-colors" />
                            </div>
                            <div className="tw-relative">
                                <label className="tw-absolute tw-left-3 tw-top-1/2 tw--translate-y-1/2 tw-text-[10px] tw-font-bold tw-text-slate-400 tw-uppercase">Ирэх:</label>
                                <input type="time" required value={newSchedule.startTime} onChange={(e) => setNewSchedule({...newSchedule, startTime: e.target.value})} className="tw-w-full tw-pl-12 tw-pr-3 tw-py-2.5 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg tw-text-sm tw-font-bold focus:tw-outline-none focus:tw-border-amber-500 focus:tw-bg-white tw-transition-colors" />
                            </div>
                            <div className="tw-relative">
                                <label className="tw-absolute tw-left-3 tw-top-1/2 tw--translate-y-1/2 tw-text-[10px] tw-font-bold tw-text-slate-400 tw-uppercase">Тарах:</label>
                                <input type="time" required value={newSchedule.endTime} onChange={(e) => setNewSchedule({...newSchedule, endTime: e.target.value})} className="tw-w-full tw-pl-12 tw-pr-3 tw-py-2.5 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg tw-text-sm tw-font-bold focus:tw-outline-none focus:tw-border-amber-500 focus:tw-bg-white tw-transition-colors" />
                            </div>
                        </div>
                        <button type="submit" disabled={isSaving} className="tw-w-full tw-py-2.5 tw-bg-slate-800 hover:tw-bg-slate-900 tw-text-white tw-rounded-lg tw-font-bold tw-text-sm tw-transition-colors"><FiPlus className="tw-inline" /> Хуваарь нэмэх</button>
                    </form>
                    <div className="tw-p-4 tw-overflow-y-auto tw-flex-1 custom-scrollbar">
                        {isLoading ? <div className="tw-text-center tw-text-amber-500 tw-text-sm tw-py-10">Уншиж байна...</div> : schedules.length === 0 ? <div className="tw-text-center tw-text-slate-400 tw-text-sm tw-py-10">Хоосон байна.</div> : (
                            <ul className="tw-m-0 tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-2">
                                {schedules.map((sched) => (
                                    <li key={sched.id} className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-xl tw-px-4 tw-py-3 tw-flex tw-justify-between tw-items-center group hover:tw-border-amber-300 tw-transition-colors">
                                        <div className="tw-flex tw-items-center tw-gap-4">
                                            <div className="tw-w-10 tw-h-10 tw-bg-amber-50 tw-text-amber-600 tw-border tw-border-amber-100 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-shadow-sm"><FiLayers size={16} /></div>
                                            <div><span className="tw-block tw-font-bold tw-text-slate-800 tw-text-sm">{sched.name}</span><span className="tw-block tw-text-xs tw-font-bold tw-amber-500 tw-mt-1">{sched.schedule}</span></div>
                                        </div>
                                        <button onClick={() => handleDeleteSchedule(sched.id, sched.name, sched.schedule)} className="tw-p-2 tw-bg-rose-50 hover:tw-bg-rose-500 tw-text-rose-500 hover:tw-text-white tw-rounded-lg tw-transition-colors" title="Устгах">
                                            <FiTrash2 size={16} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {/* 5. ХҮСЭЛТ БАТЛАХ ЭРХТЭЙ УДИРДЛАГА */}
                <div className="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border tw-border-slate-200 tw-overflow-hidden tw-flex tw-flex-col tw-h-[450px]">
                    <div className="tw-px-6 tw-py-4 tw-border-b tw-border-slate-200 tw-bg-slate-50/50 tw-flex tw-items-center tw-gap-2">
                        <FiUserCheck className="tw-text-indigo-500" size={18} />
                        <h3 className="tw-text-sm tw-font-bold tw-text-slate-800 tw-m-0 tw-uppercase tw-tracking-wider">Хүсэлт батлах удирдлагууд</h3>
                    </div>
                    <form onSubmit={handleAddApprover} className="tw-p-4 tw-border-b tw-border-slate-200 tw-bg-white tw-flex-shrink-0">
                        <div className="tw-flex tw-gap-2 tw-items-stretch">
                            
                            <div className="tw-relative tw-flex-1" ref={dropdownRef}>
                                <div 
                                    onClick={() => setIsApproverDropdownOpen(!isApproverDropdownOpen)}
                                    className="tw-w-full tw-h-full tw-px-4 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg tw-text-sm tw-font-bold tw-text-slate-800 hover:tw-bg-white hover:tw-border-indigo-500 tw-transition-colors tw-cursor-pointer tw-flex tw-items-center tw-justify-between"
                                >
                                    <span className="tw-truncate">
                                        {selectedApproverEmp ? `${selectedApproverEmp.firstName || selectedApproverEmp.name} (${selectedApproverEmp.emp_id})` : "-- Ажилтан сонгох --"}
                                    </span>
                                    <FiChevronDown className={`tw-text-slate-400 tw-transition-transform ${isApproverDropdownOpen ? 'tw-rotate-180' : ''}`} />
                                </div>

                                {isApproverDropdownOpen && (
                                    <div className="tw-absolute tw-z-50 tw-top-full tw-left-0 tw-w-full tw-mt-1 tw-bg-white tw-border tw-border-slate-200 tw-rounded-xl tw-shadow-xl tw-overflow-hidden tw-animate-fade-in-up">
                                        <div className="tw-p-2 tw-border-b tw-border-slate-100 tw-bg-slate-50/50">
                                            <div className="tw-relative">
                                                <FiSearch className="tw-absolute tw-left-3 tw-top-1/2 tw--translate-y-1/2 tw-text-slate-400" size={14} />
                                                <input 
                                                    type="text" 
                                                    autoFocus
                                                    placeholder="Нэр, Код хайх..." 
                                                    value={approverSearchText}
                                                    onChange={(e) => setApproverSearchText(e.target.value)}
                                                    className="tw-w-full tw-pl-8 tw-pr-3 tw-py-2 tw-bg-white tw-border tw-border-slate-200 tw-rounded-lg tw-text-sm focus:tw-outline-none focus:tw-border-indigo-500"
                                                />
                                            </div>
                                        </div>
                                        <div className="tw-max-h-48 tw-overflow-y-auto custom-scrollbar">
                                            {filteredEmployeesForDropdown.length === 0 ? (
                                                <div className="tw-p-4 tw-text-center tw-text-xs tw-text-slate-400">Илэрц олдсонгүй</div>
                                            ) : (
                                                filteredEmployeesForDropdown.map(emp => (
                                                    <div 
                                                        key={emp.emp_id} 
                                                        onClick={() => {
                                                            setSelectedApproverEmp(emp);
                                                            setIsApproverDropdownOpen(false);
                                                            setApproverSearchText("");
                                                        }}
                                                        className="tw-px-4 tw-py-2.5 tw-cursor-pointer hover:tw-bg-indigo-50 tw-border-b tw-border-slate-50 last:tw-border-0 tw-transition-colors"
                                                    >
                                                        <div className="tw-text-sm tw-font-bold tw-text-slate-800">{emp.lastName?.charAt(0) || ''}. {emp.firstName || emp.name}</div>
                                                        <div className="tw-text-[10px] tw-font-bold tw-indigo-500 tw-mt-0.5">{emp.emp_id} • {emp.position || "Албан тушаалгүй"}</div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <button type="submit" disabled={isSaving} className="tw-px-4 tw-py-2 tw-bg-slate-800 hover:tw-bg-slate-900 tw-text-white tw-rounded-lg tw-font-bold tw-text-sm tw-transition-colors tw-flex-shrink-0">Эрх өгөх</button>
                        </div>
                    </form>
                    <div className="tw-p-4 tw-bg-slate-50/30 tw-overflow-y-auto tw-flex-1 custom-scrollbar">
                        {approvers.length === 0 ? <div className="tw-text-center tw-text-slate-400 tw-text-sm tw-py-10">Эрхтэй хүн байхгүй байна.</div> : (
                            <ul className="tw-m-0 tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-2">
                                {approvers.map((app) => (
                                    <li key={app.id} className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-xl tw-p-3 tw-flex tw-justify-between tw-items-center group hover:tw-border-indigo-300 tw-transition-colors">
                                        <div className="tw-flex tw-items-center tw-gap-3">
                                            <div className="tw-w-8 tw-h-8 tw-bg-indigo-50 tw-text-indigo-600 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-font-bold tw-text-xs">{app.name.charAt(0)}</div>
                                            <div>
                                                <div className="tw-font-bold tw-text-slate-800 tw-text-sm">{app.name}</div>
                                                <div className="tw-text-[10px] tw-text-slate-500 tw-mt-0.5">{app.position} • {app.email}</div>
                                            </div>
                                        </div>
                                        <button onClick={() => handleDeleteApprover(app.id, app.name)} className="tw-p-2 tw-bg-rose-50 hover:tw-bg-rose-500 tw-text-rose-500 hover:tw-text-white tw-rounded-lg tw-transition-colors" title="Эрх хасах">
                                            <FiTrash2 size={16} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {/* 6. БАЯРЫН ӨДӨР */}
                <div className="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border tw-border-slate-200 tw-overflow-hidden tw-flex tw-flex-col tw-h-[450px]">
                    <div className="tw-px-6 tw-py-4 tw-border-b tw-border-slate-200 tw-bg-slate-50/50 tw-flex tw-items-center tw-gap-2">
                        <FiCalendar className="tw-text-rose-500" size={18} />
                        <h3 className="tw-text-sm tw-font-bold tw-text-slate-800 tw-m-0 tw-uppercase tw-tracking-wider">Нийтээр амрах баяр</h3>
                    </div>
                    
                    <div className="tw-flex tw-flex-col tw-flex-1 tw-overflow-hidden">
                        <form onSubmit={handleAddHoliday} className="tw-p-4 tw-border-b tw-border-slate-200 tw-bg-white tw-flex-shrink-0">
                            <div className="tw-flex tw-gap-2">
                                <input type="text" required placeholder="Ж: Шинэ жил, Цагаан сар..." value={newHoliday.name} onChange={(e) => setNewHoliday({...newHoliday, name: e.target.value})} className="tw-flex-1 tw-px-3 tw-py-2 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg tw-text-sm tw-font-medium focus:tw-outline-none focus:tw-border-rose-500 focus:tw-bg-white tw-transition-colors" />
                                <button type="submit" disabled={isSaving} className="tw-px-4 tw-py-2 tw-bg-slate-800 hover:tw-bg-slate-900 tw-text-white tw-rounded-lg tw-font-bold tw-text-sm tw-transition-colors"><FiPlus /></button>
                            </div>
                        </form>
                        
                        <div className="tw-flex tw-flex-1 tw-overflow-hidden">
                            <div className="tw-w-1/2 tw-p-3 tw-bg-slate-50/50 tw-border-r tw-border-slate-200 tw-flex tw-justify-center tw-items-start custom-calendar-wrapper tw-overflow-y-auto custom-scrollbar">
                                <DatePicker 
                                    selected={newHoliday.date} 
                                    onChange={(date) => setNewHoliday({...newHoliday, date: date})} 
                                    inline 
                                    locale="mn"
                                    highlightDates={highlightedHolidays}
                                />
                            </div>
                            
                            <div className="tw-w-1/2 tw-p-4 tw-overflow-y-auto custom-scrollbar">
                                {isLoading ? <div className="tw-text-center tw-text-rose-500 tw-text-sm tw-py-10">Уншиж байна...</div> : holidays.length === 0 ? <div className="tw-text-center tw-text-slate-400 tw-text-sm tw-py-10">Хоосон байна.</div> : (
                                    <ul className="tw-m-0 tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-2">
                                        {holidays.map((hol) => (
                                            <li key={hol.id} className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-lg tw-px-3 tw-py-2.5 tw-flex tw-justify-between tw-items-center group hover:tw-border-rose-300 tw-transition-colors tw-shadow-sm">
                                                <div>
                                                    <span className="tw-block tw-font-bold tw-text-slate-800 tw-text-xs">{hol.name}</span>
                                                    <span className="tw-block tw-text-[10px] tw-font-bold tw-rose-500 tw-mt-0.5">{hol.date}</span>
                                                </div>
                                                <button onClick={() => handleDeleteHoliday(hol.id, hol.name)} className="tw-p-2 tw-bg-rose-50 hover:tw-bg-rose-500 tw-text-rose-500 hover:tw-text-white tw-rounded-lg tw-transition-colors" title="Устгах">
                                                    <FiTrash2 size={14} />
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <style jsx="true">{`
                .custom-scrollbar::-webkit-scrollbar { width: 4px; height: 4px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 10px; }
                
                .custom-calendar-wrapper .react-datepicker__day--highlighted {
                    background-color: #f43f5e !important;
                    color: white !important;
                    border-radius: 50%;
                    font-weight: bold;
                }
                
                .custom-calendar-wrapper .react-datepicker__day--selected,
                .custom-calendar-wrapper .react-datepicker__day--keyboard-selected {
                    background-color: #3b82f6 !important;
                    color: white !important;
                    border-radius: 50%;
                    font-weight: 900;
                }

                .custom-calendar-wrapper .react-datepicker {
                    border: none;
                    background: transparent;
                    font-family: inherit;
                    width: 100%;
                }
                .custom-calendar-wrapper .react-datepicker__month-container {
                    width: 100%;
                }
                .custom-calendar-wrapper .react-datepicker__header {
                    background: transparent;
                    border-bottom: none;
                    padding-top: 10px;
                }
                .custom-calendar-wrapper .react-datepicker__current-month {
                    font-size: 13px;
                    font-weight: 800;
                    color: #1e293b;
                    margin-bottom: 5px;
                }
                .custom-calendar-wrapper .react-datepicker__day-names {
                    display: flex;
                    justify-content: space-between;
                }
                .custom-calendar-wrapper .react-datepicker__day-name {
                    font-size: 10px;
                    font-weight: 700;
                    color: #94a3b8;
                    width: 30px;
                }
                .custom-calendar-wrapper .react-datepicker__week {
                    display: flex;
                    justify-content: space-between;
                }
                .custom-calendar-wrapper .react-datepicker__day {
                    font-size: 11px;
                    font-weight: 600;
                    color: #334155;
                    width: 30px;
                    line-height: 30px;
                    border-radius: 50%;
                }
            `}</style>
        </div>
    );
}